import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// 修复Leaflet默认图标问题
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// 日本主要城市坐标映射（含政令指定都市的区级坐标）
const japanCityCoordinates = {
  // ========== 北海道 ==========
  '北海道': { lat: 43.2642, lng: 142.8694 },
  '札幌市': { lat: 43.0642, lng: 141.3469 },
  '函館市': { lat: 41.7687, lng: 140.7288 },
  '旭川市': { lat: 43.7706, lng: 142.3649 },
  // 札幌市10区
  '札幌市中央区': { lat: 43.0553, lng: 141.3409 },
  '札幌市北区': { lat: 43.0907, lng: 141.3409 },
  '札幌市東区': { lat: 43.0764, lng: 141.3636 },
  '札幌市白石区': { lat: 43.0481, lng: 141.4064 },
  '札幌市厚別区': { lat: 43.0375, lng: 141.4739 },
  '札幌市豊平区': { lat: 43.0314, lng: 141.3831 },
  '札幌市清田区': { lat: 42.9897, lng: 141.4464 },
  '札幌市南区': { lat: 42.9897, lng: 141.3531 },
  '札幌市西区': { lat: 43.0742, lng: 141.3031 },
  '札幌市手稲区': { lat: 43.1164, lng: 141.2464 },

  // ========== 東北 ==========
  '青森県': { lat: 40.8244, lng: 140.7400 },
  '青森市': { lat: 40.8244, lng: 140.7400 },
  '岩手県': { lat: 39.7036, lng: 141.1527 },
  '盛岡市': { lat: 39.7036, lng: 141.1527 },
  '宮城県': { lat: 38.2682, lng: 140.8719 },
  '仙台市': { lat: 38.2682, lng: 140.8719 },
  // 仙台市5区
  '仙台市青葉区': { lat: 38.2682, lng: 140.8719 },
  '仙台市宮城野区': { lat: 38.2636, lng: 140.9164 },
  '仙台市若林区': { lat: 38.2353, lng: 140.9064 },
  '仙台市太白区': { lat: 38.2219, lng: 140.8764 },
  '仙台市泉区': { lat: 38.3264, lng: 140.8764 },
  '秋田県': { lat: 39.7186, lng: 140.1024 },
  '秋田市': { lat: 39.7186, lng: 140.1024 },
  '山形県': { lat: 38.2404, lng: 140.3636 },
  '山形市': { lat: 38.2404, lng: 140.3636 },
  '福島県': { lat: 37.7503, lng: 140.4676 },
  '福島市': { lat: 37.7503, lng: 140.4676 },

  // ========== 関東 ==========
  '茨城県': { lat: 36.3418, lng: 140.4468 },
  '水戸市': { lat: 36.3418, lng: 140.4468 },
  '栃木県': { lat: 36.5657, lng: 139.8836 },
  '宇都宮市': { lat: 36.5657, lng: 139.8836 },
  '群馬県': { lat: 36.3911, lng: 139.0608 },
  '前橋市': { lat: 36.3911, lng: 139.0608 },
  '埼玉県': { lat: 35.8617, lng: 139.6455 },
  'さいたま市': { lat: 35.8617, lng: 139.6455 },
  // さいたま市10区
  'さいたま市西区': { lat: 35.9064, lng: 139.5531 },
  'さいたま市北区': { lat: 35.9264, lng: 139.6164 },
  'さいたま市大宮区': { lat: 35.9064, lng: 139.6264 },
  'さいたま市見沼区': { lat: 35.9164, lng: 139.6664 },
  'さいたま市中央区': { lat: 35.8764, lng: 139.6164 },
  'さいたま市桜区': { lat: 35.8464, lng: 139.5964 },
  'さいたま市浦和区': { lat: 35.8664, lng: 139.6464 },
  'さいたま市南区': { lat: 35.8364, lng: 139.6564 },
  'さいたま市緑区': { lat: 35.8564, lng: 139.6964 },
  'さいたま市岩槻区': { lat: 35.9464, lng: 139.7064 },
  '川越市': { lat: 35.9083, lng: 139.4853 },
  '熊谷市': { lat: 36.1464, lng: 139.3886 },
  '川口市': { lat: 35.8081, lng: 139.7244 },
  '行田市': { lat: 36.1397, lng: 139.4547 },
  '秩父市': { lat: 35.9925, lng: 139.0856 },
  '所沢市': { lat: 35.7992, lng: 139.4689 },
  '飯能市': { lat: 35.8558, lng: 139.3264 },
  '加須市': { lat: 36.1314, lng: 139.6017 },
  '本庄市': { lat: 36.2444, lng: 139.1906 },
  '東松山市': { lat: 36.0392, lng: 139.3925 },
  '春日部市': { lat: 35.9756, lng: 139.7547 },
  '狭山市': { lat: 35.8528, lng: 139.4108 },
  '羽生市': { lat: 36.1719, lng: 139.5489 },
  '鴻巣市': { lat: 36.0656, lng: 139.5206 },
  '深谷市': { lat: 36.1972, lng: 139.2814 },
  '上尾市': { lat: 35.9764, lng: 139.5928 },
  '草加市': { lat: 35.8256, lng: 139.7944 },
  '越谷市': { lat: 35.8906, lng: 139.7908 },
  '蕨市': { lat: 35.8317, lng: 139.6781 },
  '戸田市': { lat: 35.8175, lng: 139.6789 },
  '入間市': { lat: 35.8364, lng: 139.3900 },
  '朝霞市': { lat: 35.7975, lng: 139.5933 },
  '志木市': { lat: 35.8372, lng: 139.5800 },
  '和光市': { lat: 35.7811, lng: 139.6067 },
  '新座市': { lat: 35.7939, lng: 139.5647 },
  '桶川市': { lat: 36.0031, lng: 139.5906 },
  '久喜市': { lat: 36.0656, lng: 139.6669 },
  '北本市': { lat: 36.0269, lng: 139.5269 },
  '八潮市': { lat: 35.8228, lng: 139.8369 },
  '富士見市': { lat: 35.8569, lng: 139.5494 },
  '三郷市': { lat: 35.8328, lng: 139.8700 },
  '蓮田市': { lat: 36.0419, lng: 139.6569 },
  '坂戸市': { lat: 35.9572, lng: 139.4025 },
  '幸手市': { lat: 36.0081, lng: 139.7308 },
  '鶴ヶ島市': { lat: 35.9342, lng: 139.4172 },
  '日高市': { lat: 35.9075, lng: 139.3428 },
  '吉川市': { lat: 35.8917, lng: 139.8419 },
  'ふじみ野市': { lat: 35.8797, lng: 139.5169 },
  '白岡市': { lat: 36.0194, lng: 139.6756 },

  '千葉県': { lat: 35.6074, lng: 140.1065 },
  '千葉市': { lat: 35.6074, lng: 140.1065 },
  // 千葉市6区
  '千葉市中央区': { lat: 35.6074, lng: 140.1065 },
  '千葉市花見川区': { lat: 35.6664, lng: 140.0764 },
  '千葉市稲毛区': { lat: 35.6364, lng: 140.1064 },
  '千葉市若葉区': { lat: 35.6164, lng: 140.1564 },
  '千葉市緑区': { lat: 35.5564, lng: 140.1564 },
  '千葉市美浜区': { lat: 35.6364, lng: 140.0564 },
  '銚子市': { lat: 35.7342, lng: 140.8231 },
  '市川市': { lat: 35.7225, lng: 139.9306 },
  '船橋市': { lat: 35.6947, lng: 139.9828 },
  '館山市': { lat: 34.9964, lng: 139.8736 },
  '木更津市': { lat: 35.3789, lng: 139.9169 },
  '松戸市': { lat: 35.7875, lng: 139.9019 },
  '野田市': { lat: 35.9561, lng: 139.8750 },
  '茂原市': { lat: 35.4297, lng: 140.2889 },
  '成田市': { lat: 35.7764, lng: 140.3175 },
  '佐倉市': { lat: 35.7244, lng: 140.2231 },
  '東金市': { lat: 35.5606, lng: 140.3661 },
  '旭市': { lat: 35.7206, lng: 140.6486 },
  '習志野市': { lat: 35.6761, lng: 140.0264 },
  '柏市': { lat: 35.8647, lng: 139.9692 },
  '勝浦市': { lat: 35.1522, lng: 140.3069 },
  '市原市': { lat: 35.4978, lng: 140.1175 },
  '流山市': { lat: 35.8564, lng: 139.9006 },
  '八千代市': { lat: 35.7231, lng: 140.0994 },
  '我孫子市': { lat: 35.8644, lng: 140.0244 },
  '鴨川市': { lat: 35.1144, lng: 140.0978 },
  '鎌ケ谷市': { lat: 35.7769, lng: 139.9986 },
  '君津市': { lat: 35.3256, lng: 139.8969 },
  '富津市': { lat: 35.3044, lng: 139.8431 },
  '浦安市': { lat: 35.6544, lng: 139.9031 },
  '四街道市': { lat: 35.6656, lng: 140.1669 },
  '袖ケ浦市': { lat: 35.4306, lng: 139.9569 },
  '八街市': { lat: 35.6656, lng: 140.3169 },
  '印西市': { lat: 35.8328, lng: 140.1456 },
  '白井市': { lat: 35.7919, lng: 140.0569 },
  '富里市': { lat: 35.7289, lng: 140.3419 },
  '南房総市': { lat: 35.0389, lng: 139.8331 },
  '匝瑳市': { lat: 35.7031, lng: 140.5569 },
  '香取市': { lat: 35.8969, lng: 140.4989 },
  '山武市': { lat: 35.6069, lng: 140.4131 },
  'いすみ市': { lat: 35.2569, lng: 140.3931 },
  '大網白里市': { lat: 35.5206, lng: 140.3206 },

  // ========== 東京都 ==========
  '東京都': { lat: 35.6762, lng: 139.6503 },
  // 東京都23区（使用完整格式避免与其他城市冲突）
  '東京都千代田区': { lat: 35.6938, lng: 139.7536 },
  '東京都中央区': { lat: 35.6713, lng: 139.7715 },
  '東京都港区': { lat: 35.6581, lng: 139.7414 },
  '東京都新宿区': { lat: 35.6896, lng: 139.6917 },
  '東京都文京区': { lat: 35.7081, lng: 139.7514 },
  '東京都台東区': { lat: 35.7108, lng: 139.7794 },
  '東京都墨田区': { lat: 35.7101, lng: 139.8107 },
  '東京都江東区': { lat: 35.6732, lng: 139.8171 },
  '東京都品川区': { lat: 35.6092, lng: 139.7301 },
  '東京都目黒区': { lat: 35.6419, lng: 139.6982 },
  '東京都大田区': { lat: 35.5618, lng: 139.7163 },
  '東京都世田谷区': { lat: 35.6464, lng: 139.6532 },
  '東京都渋谷区': { lat: 35.6581, lng: 139.7013 },
  '東京都中野区': { lat: 35.7090, lng: 139.6656 },
  '東京都杉並区': { lat: 35.6993, lng: 139.6368 },
  '東京都豊島区': { lat: 35.7298, lng: 139.7156 },
  '東京都北区': { lat: 35.7537, lng: 139.7369 },
  '東京都荒川区': { lat: 35.7362, lng: 139.7832 },
  '東京都板橋区': { lat: 35.7501, lng: 139.7094 },
  '東京都練馬区': { lat: 35.7356, lng: 139.6522 },
  '東京都足立区': { lat: 35.7751, lng: 139.8045 },
  '東京都葛飾区': { lat: 35.7448, lng: 139.8485 },
  '東京都江戸川区': { lat: 35.7068, lng: 139.8683 },
  // 保留原有单独区名（向下兼容，但优先匹配完整格式）
  '千代田区': { lat: 35.6938, lng: 139.7536 },
  '新宿区': { lat: 35.6896, lng: 139.6917 },
  '文京区': { lat: 35.7081, lng: 139.7514 },
  '台東区': { lat: 35.7108, lng: 139.7794 },
  '墨田区': { lat: 35.7101, lng: 139.8107 },
  '江東区': { lat: 35.6732, lng: 139.8171 },
  '品川区': { lat: 35.6092, lng: 139.7301 },
  '目黒区': { lat: 35.6419, lng: 139.6982 },
  '大田区': { lat: 35.5618, lng: 139.7163 },
  '世田谷区': { lat: 35.6464, lng: 139.6532 },
  '渋谷区': { lat: 35.6581, lng: 139.7013 },
  '中野区': { lat: 35.7090, lng: 139.6656 },
  '杉並区': { lat: 35.6993, lng: 139.6368 },
  '豊島区': { lat: 35.7298, lng: 139.7156 },
  '北区': { lat: 35.7537, lng: 139.7369 },
  '荒川区': { lat: 35.7362, lng: 139.7832 },
  '板橋区': { lat: 35.7501, lng: 139.7094 },
  '練馬区': { lat: 35.7356, lng: 139.6522 },
  '足立区': { lat: 35.7751, lng: 139.8045 },
  '葛飾区': { lat: 35.7448, lng: 139.8485 },
  '江戸川区': { lat: 35.7068, lng: 139.8683 },
  '八王子市': { lat: 35.6558, lng: 139.3239 },
  '立川市': { lat: 35.7142, lng: 139.4075 },
  '武蔵野市': { lat: 35.7181, lng: 139.5658 },
  '三鷹市': { lat: 35.6831, lng: 139.5594 },
  '青梅市': { lat: 35.7881, lng: 139.2789 },
  '府中市': { lat: 35.6697, lng: 139.4775 },
  '昭島市': { lat: 35.7061, lng: 139.3531 },
  '調布市': { lat: 35.6517, lng: 139.5406 },
  '町田市': { lat: 35.5467, lng: 139.4283 },
  '小金井市': { lat: 35.6989, lng: 139.5031 },
  '小平市': { lat: 35.7283, lng: 139.4775 },
  '日野市': { lat: 35.6711, lng: 139.3969 },
  '東村山市': { lat: 35.7550, lng: 139.4689 },
  '国分寺市': { lat: 35.7022, lng: 139.4606 },
  '国立市': { lat: 35.6842, lng: 139.4417 },
  '福生市': { lat: 35.7381, lng: 139.3281 },
  '狛江市': { lat: 35.6356, lng: 139.5781 },
  '東大和市': { lat: 35.7442, lng: 139.4269 },
  '清瀬市': { lat: 35.7853, lng: 139.5261 },
  '東久留米市': { lat: 35.7581, lng: 139.5297 },
  '武蔵村山市': { lat: 35.7542, lng: 139.3897 },
  '多摩市': { lat: 35.6369, lng: 139.4467 },
  '稲城市': { lat: 35.6378, lng: 139.5050 },
  '羽村市': { lat: 35.7672, lng: 139.3106 },
  'あきる野市': { lat: 35.7289, lng: 139.2944 },
  '西東京市': { lat: 35.7253, lng: 139.5381 },

  '神奈川県': { lat: 35.4478, lng: 139.6425 },
  '横浜市': { lat: 35.4478, lng: 139.6425 },
  // 横浜市18区
  '横浜市鶴見区': { lat: 35.5108, lng: 139.6831 },
  '横浜市神奈川区': { lat: 35.4764, lng: 139.6331 },
  '横浜市西区': { lat: 35.4564, lng: 139.6231 },
  '横浜市中区': { lat: 35.4378, lng: 139.6506 },
  '横浜市南区': { lat: 35.4278, lng: 139.6006 },
  '横浜市保土ケ谷区': { lat: 35.4578, lng: 139.5906 },
  '横浜市磯子区': { lat: 35.4078, lng: 139.6206 },
  '横浜市金沢区': { lat: 35.3478, lng: 139.6206 },
  '横浜市港北区': { lat: 35.5278, lng: 139.6306 },
  '横浜市戸塚区': { lat: 35.3978, lng: 139.5306 },
  '横浜市港南区': { lat: 35.4078, lng: 139.5806 },
  '横浜市旭区': { lat: 35.4678, lng: 139.5406 },
  '横浜市緑区': { lat: 35.5078, lng: 139.5306 },
  '横浜市瀬谷区': { lat: 35.4678, lng: 139.5006 },
  '横浜市栄区': { lat: 35.3678, lng: 139.5506 },
  '横浜市泉区': { lat: 35.4278, lng: 139.4906 },
  '横浜市青葉区': { lat: 35.5478, lng: 139.5306 },
  '横浜市都筑区': { lat: 35.5478, lng: 139.5706 },
  '川崎市': { lat: 35.5308, lng: 139.7029 },
  // 川崎市7区
  '川崎市川崎区': { lat: 35.5308, lng: 139.7329 },
  '川崎市幸区': { lat: 35.5408, lng: 139.6929 },
  '川崎市中原区': { lat: 35.5708, lng: 139.6529 },
  '川崎市高津区': { lat: 35.5908, lng: 139.6129 },
  '川崎市多摩区': { lat: 35.6208, lng: 139.5629 },
  '川崎市宮前区': { lat: 35.5808, lng: 139.5729 },
  '川崎市麻生区': { lat: 35.6008, lng: 139.5029 },
  '相模原市': { lat: 35.5707, lng: 139.3687 },
  // 相模原市3区
  '相模原市緑区': { lat: 35.6107, lng: 139.3287 },
  '相模原市中央区': { lat: 35.5607, lng: 139.3787 },
  '相模原市南区': { lat: 35.5207, lng: 139.4087 },
  '横須賀市': { lat: 35.2806, lng: 139.6667 },
  '平塚市': { lat: 35.3275, lng: 139.3472 },
  '鎌倉市': { lat: 35.3194, lng: 139.5469 },
  '藤沢市': { lat: 35.3386, lng: 139.4894 },
  '小田原市': { lat: 35.2561, lng: 139.1569 },
  '茅ヶ崎市': { lat: 35.3306, lng: 139.4039 },
  '逗子市': { lat: 35.2947, lng: 139.5789 },
  '三浦市': { lat: 35.1444, lng: 139.6178 },
  '秦野市': { lat: 35.3717, lng: 139.2239 },
  '厚木市': { lat: 35.4428, lng: 139.3661 },
  '大和市': { lat: 35.4844, lng: 139.4575 },
  '伊勢原市': { lat: 35.4000, lng: 139.3142 },
  '海老名市': { lat: 35.4508, lng: 139.3906 },
  '座間市': { lat: 35.4881, lng: 139.4089 },
  '南足柄市': { lat: 35.3100, lng: 139.1128 },
  '綾瀬市': { lat: 35.4372, lng: 139.4258 },

  // 中部
  '新潟県': { lat: 37.9026, lng: 139.0236 },
  '新潟市': { lat: 37.9026, lng: 139.0236 },
  '富山県': { lat: 36.6953, lng: 137.2113 },
  '富山市': { lat: 36.6953, lng: 137.2113 },
  '石川県': { lat: 36.5946, lng: 136.6256 },
  '金沢市': { lat: 36.5946, lng: 136.6256 },
  '福井県': { lat: 36.0652, lng: 136.2216 },
  '福井市': { lat: 36.0652, lng: 136.2216 },
  '山梨県': { lat: 35.6642, lng: 138.5686 },
  '甲府市': { lat: 35.6642, lng: 138.5686 },
  '長野県': { lat: 36.6513, lng: 138.1811 },
  '長野市': { lat: 36.6513, lng: 138.1811 },
  '岐阜県': { lat: 35.3912, lng: 136.7223 },
  '岐阜市': { lat: 35.3912, lng: 136.7223 },
  '静岡県': { lat: 34.9756, lng: 138.3827 },
  '静岡市': { lat: 34.9756, lng: 138.3827 },
  '愛知県': { lat: 35.1804, lng: 136.9066 },
  '名古屋市': { lat: 35.1804, lng: 136.9066 },
  // 名古屋市16区
  '名古屋市千種区': { lat: 35.1704, lng: 136.9466 },
  '名古屋市東区': { lat: 35.1904, lng: 136.9266 },
  '名古屋市北区': { lat: 35.2104, lng: 136.9166 },
  '名古屋市西区': { lat: 35.1904, lng: 136.8866 },
  '名古屋市中村区': { lat: 35.1704, lng: 136.8666 },
  '名古屋市中区': { lat: 35.1704, lng: 136.9066 },
  '名古屋市昭和区': { lat: 35.1504, lng: 136.9366 },
  '名古屋市瑞穂区': { lat: 35.1304, lng: 136.9366 },
  '名古屋市熱田区': { lat: 35.1304, lng: 136.9066 },
  '名古屋市中川区': { lat: 35.1404, lng: 136.8566 },
  '名古屋市港区': { lat: 35.1004, lng: 136.8766 },
  '名古屋市南区': { lat: 35.1104, lng: 136.9266 },
  '名古屋市守山区': { lat: 35.2104, lng: 136.9766 },
  '名古屋市緑区': { lat: 35.0904, lng: 136.9666 },
  '名古屋市名東区': { lat: 35.1804, lng: 136.9866 },
  '名古屋市天白区': { lat: 35.1304, lng: 136.9766 },
  '豊橋市': { lat: 34.7694, lng: 137.3914 },
  '岡崎市': { lat: 34.9556, lng: 137.1742 },
  '一宮市': { lat: 35.3031, lng: 136.8003 },
  '瀬戸市': { lat: 35.2242, lng: 137.0839 },
  '半田市': { lat: 34.8956, lng: 136.9372 },
  '春日井市': { lat: 35.2481, lng: 136.9719 },
  '豊川市': { lat: 34.8267, lng: 137.3736 },
  '津島市': { lat: 35.1772, lng: 136.7397 },
  '碧南市': { lat: 34.8856, lng: 136.9908 },
  '刈谷市': { lat: 34.9886, lng: 137.0025 },
  '豊田市': { lat: 35.0831, lng: 137.1564 },
  '安城市': { lat: 34.9572, lng: 137.0808 },
  '西尾市': { lat: 34.8631, lng: 137.0639 },
  '蒲郡市': { lat: 34.8306, lng: 137.2172 },
  '犬山市': { lat: 35.3778, lng: 136.9442 },
  '常滑市': { lat: 34.8894, lng: 136.8369 },
  '江南市': { lat: 35.3314, lng: 136.8706 },
  '小牧市': { lat: 35.2914, lng: 136.9072 },
  '稲沢市': { lat: 35.2481, lng: 136.7794 },
  '新城市': { lat: 34.9006, lng: 137.4956 },
  '東海市': { lat: 35.0228, lng: 136.9025 },
  '大府市': { lat: 35.0128, lng: 136.9639 },
  '知多市': { lat: 34.9978, lng: 136.8558 },
  '知立市': { lat: 35.0006, lng: 137.0481 },
  '尾張旭市': { lat: 35.2167, lng: 137.0339 },
  '高浜市': { lat: 34.9269, lng: 136.9881 },
  '岩倉市': { lat: 35.2794, lng: 136.8706 },
  '豊明市': { lat: 35.0539, lng: 137.0122 },
  '日進市': { lat: 35.1319, lng: 137.0375 },
  '田原市': { lat: 34.6689, lng: 137.2617 },
  '愛西市': { lat: 35.1650, lng: 136.7256 },
  '清須市': { lat: 35.2000, lng: 136.8475 },
  '北名古屋市': { lat: 35.2456, lng: 136.8656 },
  '弥富市': { lat: 35.1106, lng: 136.7239 },
  'みよし市': { lat: 35.0894, lng: 137.0739 },
  'あま市': { lat: 35.1833, lng: 136.8086 },
  '長久手市': { lat: 35.1844, lng: 137.0481 },

  // 関西
  '三重県': { lat: 34.7302, lng: 136.5085 },
  '津市': { lat: 34.7302, lng: 136.5085 },
  '四日市市': { lat: 34.9652, lng: 136.6253 },
  '伊勢市': { lat: 34.4869, lng: 136.7101 },
  '松阪市': { lat: 34.5783, lng: 136.5264 },
  '桑名市': { lat: 35.0627, lng: 136.6842 },
  '鈴鹿市': { lat: 34.8833, lng: 136.5842 },
  '名張市': { lat: 34.6278, lng: 136.1089 },
  '尾鷲市': { lat: 34.0706, lng: 136.1947 },
  '亀山市': { lat: 34.8552, lng: 136.4506 },
  '鳥羽市': { lat: 34.4831, lng: 136.8444 },
  '熊野市': { lat: 33.8881, lng: 136.1069 },
  'いなべ市': { lat: 35.1067, lng: 136.5264 },
  '志摩市': { lat: 34.3292, lng: 136.8278 },
  '伊賀市': { lat: 34.7689, lng: 136.1297 },

  '滋賀県': { lat: 35.0045, lng: 135.8686 },
  '大津市': { lat: 35.0045, lng: 135.8686 },
  '彦根市': { lat: 35.2744, lng: 136.2578 },
  '長浜市': { lat: 35.3817, lng: 136.2706 },
  '近江八幡市': { lat: 35.1280, lng: 136.0978 },
  '草津市': { lat: 35.0128, lng: 135.9594 },
  '守山市': { lat: 35.0289, lng: 135.9672 },
  '栗東市': { lat: 35.0208, lng: 135.9983 },
  '甲賀市': { lat: 34.9656, lng: 136.1681 },
  '野洲市': { lat: 35.0667, lng: 136.0167 },
  '湖南市': { lat: 34.9783, lng: 136.0842 },
  '高島市': { lat: 35.3517, lng: 136.0342 },
  '東近江市': { lat: 35.1139, lng: 136.2089 },
  '米原市': { lat: 35.3156, lng: 136.3489 },

  '京都府': { lat: 35.0211, lng: 135.7556 },
  '京都市': { lat: 35.0211, lng: 135.7556 },
  // 京都市11区
  '京都市北区': { lat: 35.0511, lng: 135.7556 },
  '京都市上京区': { lat: 35.0311, lng: 135.7556 },
  '京都市左京区': { lat: 35.0411, lng: 135.7856 },
  '京都市中京区': { lat: 35.0111, lng: 135.7556 },
  '京都市東山区': { lat: 35.0011, lng: 135.7756 },
  '京都市下京区': { lat: 34.9911, lng: 135.7556 },
  '京都市南区': { lat: 34.9711, lng: 135.7456 },
  '京都市右京区': { lat: 35.0111, lng: 135.7156 },
  '京都市伏見区': { lat: 34.9411, lng: 135.7656 },
  '京都市山科区': { lat: 34.9711, lng: 135.8156 },
  '京都市西京区': { lat: 34.9811, lng: 135.6856 },
  '福知山市': { lat: 35.2989, lng: 135.1264 },
  '舞鶴市': { lat: 35.4744, lng: 135.3856 },
  '綾部市': { lat: 35.3006, lng: 135.2561 },
  '宇治市': { lat: 34.8844, lng: 135.7994 },
  '宮津市': { lat: 35.5353, lng: 135.1953 },
  '亀岡市': { lat: 35.0139, lng: 135.5706 },
  '城陽市': { lat: 34.8525, lng: 135.7792 },
  '向日市': { lat: 34.9508, lng: 135.6972 },
  '長岡京市': { lat: 34.9269, lng: 135.6989 },
  '八幡市': { lat: 34.8753, lng: 135.7019 },
  '京田辺市': { lat: 34.8139, lng: 135.7669 },
  '京丹後市': { lat: 35.6269, lng: 135.0683 },
  '南丹市': { lat: 35.1083, lng: 135.4653 },
  '木津川市': { lat: 34.7325, lng: 135.8242 },

  '大阪府': { lat: 34.6937, lng: 135.5023 },
  '大阪市': { lat: 34.6932, lng: 135.5007 },
  // 大阪市24区（完整格式）
  '大阪市都島区': { lat: 34.7078, lng: 135.5256 },
  '大阪市福島区': { lat: 34.6928, lng: 135.4756 },
  '大阪市此花区': { lat: 34.6728, lng: 135.4456 },
  '大阪市西区': { lat: 34.6778, lng: 135.4856 },
  '大阪市港区': { lat: 34.6578, lng: 135.4556 },
  '大阪市大正区': { lat: 34.6478, lng: 135.4656 },
  '大阪市天王寺区': { lat: 34.6528, lng: 135.5156 },
  '大阪市浪速区': { lat: 34.6578, lng: 135.4956 },
  '大阪市西淀川区': { lat: 34.7128, lng: 135.4556 },
  '大阪市東淀川区': { lat: 34.7478, lng: 135.5156 },
  '大阪市東成区': { lat: 34.6678, lng: 135.5356 },
  '大阪市生野区': { lat: 34.6578, lng: 135.5456 },
  '大阪市旭区': { lat: 34.7228, lng: 135.5356 },
  '大阪市城東区': { lat: 34.6978, lng: 135.5456 },
  '大阪市阿倍野区': { lat: 34.6328, lng: 135.5156 },
  '大阪市住吉区': { lat: 34.6128, lng: 135.4956 },
  '大阪市東住吉区': { lat: 34.6128, lng: 135.5256 },
  '大阪市西成区': { lat: 34.6378, lng: 135.4856 },
  '大阪市淀川区': { lat: 34.7328, lng: 135.4856 },
  '大阪市鶴見区': { lat: 34.7028, lng: 135.5656 },
  '大阪市住之江区': { lat: 34.6028, lng: 135.4756 },
  '大阪市平野区': { lat: 34.6228, lng: 135.5556 },
  '大阪市北区': { lat: 34.7055, lng: 135.5014 },
  '大阪市中央区': { lat: 34.6784, lng: 135.5117 },
  '堺市': { lat: 34.5731, lng: 135.4825 },
  // 堺市7区
  '堺市堺区': { lat: 34.5731, lng: 135.4825 },
  '堺市中区': { lat: 34.5431, lng: 135.5125 },
  '堺市東区': { lat: 34.5531, lng: 135.5425 },
  '堺市西区': { lat: 34.5331, lng: 135.4425 },
  '堺市南区': { lat: 34.4831, lng: 135.4925 },
  '堺市北区': { lat: 34.5931, lng: 135.5125 },
  '堺市美原区': { lat: 34.5331, lng: 135.5625 },
  '岸和田市': { lat: 34.4608, lng: 135.3681 },
  '豊中市': { lat: 34.7817, lng: 135.4692 },
  '池田市': { lat: 34.8225, lng: 135.4281 },
  '吹田市': { lat: 34.7617, lng: 135.5164 },
  '泉大津市': { lat: 34.5044, lng: 135.4067 },
  '高槻市': { lat: 34.8481, lng: 135.6169 },
  '貝塚市': { lat: 34.4375, lng: 135.3583 },
  '守口市': { lat: 34.7378, lng: 135.5639 },
  '枚方市': { lat: 34.8144, lng: 135.6506 },
  '茨木市': { lat: 34.8164, lng: 135.5681 },
  '八尾市': { lat: 34.6269, lng: 135.6006 },
  '泉佐野市': { lat: 34.4081, lng: 135.3306 },
  '富田林市': { lat: 34.5000, lng: 135.5983 },
  '寝屋川市': { lat: 34.7661, lng: 135.6269 },
  '河内長野市': { lat: 34.4583, lng: 135.5619 },
  '松原市': { lat: 34.5781, lng: 135.5511 },
  '大東市': { lat: 34.7306, lng: 135.6169 },
  '和泉市': { lat: 34.4839, lng: 135.4256 },
  '箕面市': { lat: 34.8267, lng: 135.4711 },
  '柏原市': { lat: 34.5742, lng: 135.6356 },
  '羽曳野市': { lat: 34.5597, lng: 135.6067 },
  '門真市': { lat: 34.7378, lng: 135.5861 },
  '摂津市': { lat: 34.7856, lng: 135.5592 },
  '高石市': { lat: 34.5211, lng: 135.4442 },
  '藤井寺市': { lat: 34.5747, lng: 135.5981 },
  '東大阪市': { lat: 34.6781, lng: 135.6006 },
  '泉南市': { lat: 34.3628, lng: 135.2689 },
  '四條畷市': { lat: 34.7378, lng: 135.6378 },
  '交野市': { lat: 34.7878, lng: 135.6792 },
  '大阪狭山市': { lat: 34.5006, lng: 135.5633 },
  '阪南市': { lat: 34.3528, lng: 135.2092 },

  '兵庫県': { lat: 34.6913, lng: 135.1830 },
  '神戸市': { lat: 34.6913, lng: 135.1830 },
  // 神戸市9区
  '神戸市東灘区': { lat: 34.7213, lng: 135.2630 },
  '神戸市灘区': { lat: 34.7113, lng: 135.2330 },
  '神戸市兵庫区': { lat: 34.6813, lng: 135.1530 },
  '神戸市長田区': { lat: 34.6613, lng: 135.1430 },
  '神戸市須磨区': { lat: 34.6513, lng: 135.1130 },
  '神戸市垂水区': { lat: 34.6313, lng: 135.0530 },
  '神戸市北区': { lat: 34.7313, lng: 135.1230 },
  '神戸市中央区': { lat: 34.6913, lng: 135.1830 },
  '神戸市西区': { lat: 34.6813, lng: 134.9830 },
  '姫路市': { lat: 34.8161, lng: 134.6853 },
  '尼崎市': { lat: 34.7333, lng: 135.4250 },
  '明石市': { lat: 34.6464, lng: 134.9969 },
  '西宮市': { lat: 34.7381, lng: 135.3417 },
  '洲本市': { lat: 34.3419, lng: 134.8964 },
  '芦屋市': { lat: 34.7275, lng: 135.3050 },
  '伊丹市': { lat: 34.7842, lng: 135.4000 },
  '相生市': { lat: 34.8067, lng: 134.4869 },
  '豊岡市': { lat: 35.5456, lng: 134.8183 },
  '加古川市': { lat: 34.7547, lng: 134.8406 },
  '赤穂市': { lat: 34.7550, lng: 134.3906 },
  '西脇市': { lat: 34.9956, lng: 134.9653 },
  '宝塚市': { lat: 34.7994, lng: 135.3561 },
  '三木市': { lat: 34.7969, lng: 134.9869 },
  '高砂市': { lat: 34.7578, lng: 134.7889 },
  '川西市': { lat: 34.8306, lng: 135.4172 },
  '小野市': { lat: 34.8486, lng: 134.9331 },
  '三田市': { lat: 34.8883, lng: 135.2244 },
  '加西市': { lat: 34.9275, lng: 134.8456 },
  '篠山市': { lat: 35.0742, lng: 135.2183 },
  '養父市': { lat: 35.4044, lng: 134.7658 },
  '丹波市': { lat: 35.1722, lng: 135.0364 },
  '南あわじ市': { lat: 34.2956, lng: 134.7539 },
  '朝来市': { lat: 35.3383, lng: 134.8544 },
  '淡路市': { lat: 34.4306, lng: 134.9139 },
  '宍粟市': { lat: 35.0039, lng: 134.5506 },
  '加東市': { lat: 34.9181, lng: 134.9689 },
  'たつの市': { lat: 34.8583, lng: 134.5403 },

  '奈良県': { lat: 34.6851, lng: 135.8049 },
  '奈良市': { lat: 34.6851, lng: 135.8049 },
  '大和高田市': { lat: 34.5172, lng: 135.7369 },
  '大和郡山市': { lat: 34.6494, lng: 135.7833 },
  '天理市': { lat: 34.5961, lng: 135.8372 },
  '橿原市': { lat: 34.5133, lng: 135.7928 },
  '桜井市': { lat: 34.5181, lng: 135.8428 },
  '五條市': { lat: 34.3544, lng: 135.7106 },
  '御所市': { lat: 34.4628, lng: 135.7372 },
  '生駒市': { lat: 34.6917, lng: 135.7000 },
  '香芝市': { lat: 34.5442, lng: 135.7019 },
  '葛城市': { lat: 34.4858, lng: 135.7072 },
  '宇陀市': { lat: 34.5269, lng: 135.9558 },

  '和歌山県': { lat: 34.2261, lng: 135.1675 },
  '和歌山市': { lat: 34.2261, lng: 135.1675 },
  '海南市': { lat: 34.1556, lng: 135.2067 },
  '橋本市': { lat: 34.3156, lng: 135.6028 },
  '有田市': { lat: 34.0689, lng: 135.1281 },
  '御坊市': { lat: 33.8917, lng: 135.1642 },
  '田辺市': { lat: 33.7306, lng: 135.3792 },
  '新宮市': { lat: 33.7278, lng: 135.9944 },
  '紀の川市': { lat: 34.2669, lng: 135.3644 },
  '岩出市': { lat: 34.2564, lng: 135.3100 },

  // 中国
  '鳥取県': { lat: 35.5038, lng: 134.2384 },
  '鳥取市': { lat: 35.5038, lng: 134.2384 },
  '島根県': { lat: 35.4723, lng: 133.0505 },
  '松江市': { lat: 35.4723, lng: 133.0505 },
  '岡山県': { lat: 34.6617, lng: 133.9350 },
  '岡山市': { lat: 34.6617, lng: 133.9350 },
  '広島県': { lat: 34.3853, lng: 132.4553 },
  '広島市': { lat: 34.3853, lng: 132.4553 },
  '山口県': { lat: 34.1861, lng: 131.4707 },
  '山口市': { lat: 34.1861, lng: 131.4707 },

  // 四国
  '徳島県': { lat: 34.0658, lng: 134.5592 },
  '徳島市': { lat: 34.0658, lng: 134.5592 },
  '香川県': { lat: 34.3401, lng: 134.0434 },
  '高松市': { lat: 34.3401, lng: 134.0434 },
  '愛媛県': { lat: 33.8416, lng: 132.7657 },
  '松山市': { lat: 33.8416, lng: 132.7657 },
  '高知県': { lat: 33.5597, lng: 133.5311 },
  '高知市': { lat: 33.5597, lng: 133.5311 },

  // 九州
  '福岡県': { lat: 33.6064, lng: 130.4183 },
  '福岡市': { lat: 33.6064, lng: 130.4183 },
  // 福岡市7区
  '福岡市東区': { lat: 33.6264, lng: 130.4483 },
  '福岡市博多区': { lat: 33.5964, lng: 130.4283 },
  '福岡市中央区': { lat: 33.5864, lng: 130.3883 },
  '福岡市南区': { lat: 33.5564, lng: 130.4283 },
  '福岡市西区': { lat: 33.5664, lng: 130.3183 },
  '福岡市城南区': { lat: 33.5564, lng: 130.3683 },
  '福岡市早良区': { lat: 33.5664, lng: 130.3483 },
  '北九州市': { lat: 33.8834, lng: 130.8751 },
  // 北九州市7区
  '北九州市門司区': { lat: 33.9434, lng: 130.9551 },
  '北九州市若松区': { lat: 33.9134, lng: 130.7951 },
  '北九州市戸畑区': { lat: 33.9034, lng: 130.8351 },
  '北九州市小倉北区': { lat: 33.8834, lng: 130.8751 },
  '北九州市小倉南区': { lat: 33.8434, lng: 130.9151 },
  '北九州市八幡東区': { lat: 33.8634, lng: 130.8051 },
  '北九州市八幡西区': { lat: 33.8534, lng: 130.7551 },
  '大牟田市': { lat: 33.0303, lng: 130.4444 },
  '久留米市': { lat: 33.3064, lng: 130.5086 },
  '直方市': { lat: 33.7494, lng: 130.7306 },
  '飯塚市': { lat: 33.6456, lng: 130.6856 },
  '田川市': { lat: 33.6419, lng: 130.8056 },
  '柳川市': { lat: 33.1594, lng: 130.4058 },
  '八女市': { lat: 33.2119, lng: 130.5569 },
  '筑後市': { lat: 33.2081, lng: 130.4989 },
  '大川市': { lat: 33.2081, lng: 130.3831 },
  '行橋市': { lat: 33.7306, lng: 130.9831 },
  '豊前市': { lat: 33.6089, lng: 131.1239 },
  '中間市': { lat: 33.8119, lng: 130.7089 },
  '小郡市': { lat: 33.3981, lng: 130.5619 },
  '筑紫野市': { lat: 33.4944, lng: 130.5169 },
  '春日市': { lat: 33.5342, lng: 130.4706 },
  '大野城市': { lat: 33.5381, lng: 130.5106 },
  '宗像市': { lat: 33.8031, lng: 130.5456 },
  '太宰府市': { lat: 33.5133, lng: 130.5331 },
  '古賀市': { lat: 33.7269, lng: 130.4806 },
  '福津市': { lat: 33.7681, lng: 130.4931 },
  'うきは市': { lat: 33.3481, lng: 130.7631 },
  '宮若市': { lat: 33.7244, lng: 130.6669 },
  '嘉麻市': { lat: 33.5706, lng: 130.7431 },
  '朝倉市': { lat: 33.4219, lng: 130.6631 },
  'みやま市': { lat: 33.1531, lng: 130.4781 },
  '糸島市': { lat: 33.5569, lng: 130.1981 },
  '那珂川市': { lat: 33.4831, lng: 130.5256 },
  '佐賀県': { lat: 33.2494, lng: 130.2989 },
  '佐賀市': { lat: 33.2494, lng: 130.2989 },
  '長崎県': { lat: 32.7503, lng: 129.8779 },
  '長崎市': { lat: 32.7503, lng: 129.8779 },
  '熊本県': { lat: 32.7898, lng: 130.7417 },
  '熊本市': { lat: 32.7898, lng: 130.7417 },
  '大分県': { lat: 33.2382, lng: 131.6126 },
  '大分市': { lat: 33.2382, lng: 131.6126 },
  '宮崎県': { lat: 31.9077, lng: 131.4202 },
  '宮崎市': { lat: 31.9077, lng: 131.4202 },
  '鹿児島県': { lat: 31.5602, lng: 130.5581 },
  '鹿児島市': { lat: 31.5602, lng: 130.5581 },
  '沖縄県': { lat: 26.2124, lng: 127.6792 },
  '那覇市': { lat: 26.2124, lng: 127.6792 }
};

const originColorMap = {
  '日本': '#2563eb',
  '中国': '#dc2626',
  '韓国': '#7c3aed',
  'ミャンマー': '#0f766e',
  'インドネシア': '#ea580c',
  'ベトナム': '#16a34a',
  'フィリピン': '#db2777',
  '台湾': '#0891b2',
  'タイ': '#ca8a04',
  '未設定': '#64748b'
};

const fallbackOriginColors = ['#4f46e5', '#0f766e', '#be123c', '#9333ea', '#0369a1', '#b45309'];
const markerIconCache = new Map();

const normalizeOriginCountry = (nationality, fallbackLabel) => {
  const normalized = (nationality || '').trim();

  if (!normalized) {
    return fallbackLabel;
  }

  const nationalityMap = {
    '中国': '中国',
    '韩国': '韓国',
    '韓国': '韓国',
    '缅甸': 'ミャンマー',
    'ミャンマー': 'ミャンマー',
    '印度尼西亚': 'インドネシア',
    'インドネシア': 'インドネシア',
    '越南': 'ベトナム',
    'ベトナム': 'ベトナム',
    '台湾': '台湾',
    '日本': '日本',
    '菲律宾': 'フィリピン',
    'フィリピン': 'フィリピン',
    '泰国': 'タイ',
    'タイ': 'タイ'
  };

  return nationalityMap[normalized] || normalized;
};

const getFallbackColor = (label) => {
  const seed = Array.from(label).reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return fallbackOriginColors[seed % fallbackOriginColors.length];
};

const getOriginColor = (originCountry) => originColorMap[originCountry] || getFallbackColor(originCountry);

const getMarkerIcon = (color) => {
  if (!markerIconCache.has(color)) {
    markerIconCache.set(color, L.divIcon({
      className: '',
      html: `
        <div style="position: relative; width: 22px; height: 30px; display: flex; justify-content: center;">
          <span style="position: absolute; top: 0; width: 22px; height: 22px; border-radius: 9999px; background: ${color}; border: 2px solid rgba(255,255,255,0.96); box-shadow: 0 6px 14px rgba(15,23,42,0.28);"></span>
          <span style="position: absolute; top: 18px; width: 4px; height: 12px; border-radius: 9999px; background: ${color};"></span>
          <span style="position: absolute; top: 7px; width: 8px; height: 8px; border-radius: 9999px; background: rgba(255,255,255,0.96);"></span>
        </div>
      `,
      iconSize: [22, 30],
      iconAnchor: [11, 30],
      popupAnchor: [0, -26]
    }));
  }

  return markerIconCache.get(color);
};

// 地址解析函数 - 改进算法，优先匹配完整格式，避免区名冲突
const parseAddressToCoordinates = (address) => {
  if (!address) return null;

  // 获取所有位置数据
  const locations = Object.entries(japanCityCoordinates);

  // ========== Step 1: 优先匹配完整的"市+区"格式（政令指定都市） ==========
  // 这一步最重要，可以避免"大阪市北区"被"北区"匹配到东京的问题
  const fullCityWardMatches = locations
    .filter(([location]) =>
      (location.includes('市') && location.includes('区')) ||  // 如: 大阪市北区
      (location.includes('都') && location.includes('区'))     // 如: 東京都北区
    )
    .sort(([a], [b]) => b.length - a.length);  // 按长度排序，长的优先

  for (const [location, coords] of fullCityWardMatches) {
    if (address.includes(location)) {
      return { ...coords, location };
    }
  }

  // ========== Step 2: 匹配普通市区町村 ==========
  const cityMatches = locations
    .filter(([location]) =>
      (location.includes('市') || location.includes('町') || location.includes('村')) &&
      !location.includes('区')  // 排除已经在Step 1处理过的"市+区"格式
    )
    .sort(([a], [b]) => b.length - a.length);

  for (const [location, coords] of cityMatches) {
    if (address.includes(location)) {
      return { ...coords, location };
    }
  }

  // ========== Step 3: 匹配单独的区名（仅用于东京都23区的简写情况） ==========
  // 只有当地址明确包含"東京都"时，才匹配单独的区名
  if (address.includes('東京都') || address.includes('東京')) {
    const tokyoWardMatches = locations
      .filter(([location]) =>
        location.includes('区') &&
        !location.includes('市') &&
        !location.includes('都')
      )
      .sort(([a], [b]) => b.length - a.length);

    for (const [location, coords] of tokyoWardMatches) {
      if (address.includes(location)) {
        return { ...coords, location };
      }
    }
  }

  // ========== Step 4: 匹配道都府県 ==========
  const prefectureMatches = locations
    .filter(([location]) =>
      location.includes('県') || location.includes('府') || location.includes('都') || location.includes('道')
    )
    .sort(([a], [b]) => b.length - a.length);

  for (const [location, coords] of prefectureMatches) {
    if (address.includes(location)) {
      return { ...coords, location };
    }
  }

  // ========== Step 5: 返回null表示无法解析 ==========
  return null;
};

const JapanTalentMap = ({ talents = [], onTalentClick = null }) => {
  const { t } = useTranslation();
  const [mapTalents, setMapTalents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    const processedTalents = (talents || []).map((talent) => {
      const workCoords = parseAddressToCoordinates(talent.workplaceAddress);
      const originCountry = normalizeOriginCountry(talent.nationality, t('originUnset'));

      return {
        ...talent,
        workCoords,
        originCountry,
        originColor: getOriginColor(originCountry)
      };
    }).filter((talent) => talent.workCoords);

    setMapTalents(processedTalents);
    setIsLoading(false);
  }, [t, talents]);

  const legendItems = Array.from(mapTalents.reduce((acc, talent) => {
    const current = acc.get(talent.originCountry) || {
      label: talent.originCountry,
      color: talent.originColor,
      count: 0
    };

    current.count += 1;
    acc.set(talent.originCountry, current);
    return acc;
  }, new Map()).values()).sort((a, b) => (
    b.count - a.count || a.label.localeCompare(b.label, 'ja')
  ));

  // 创建图钉标记
  const createMarkers = () => {
    const markers = [];

    mapTalents.forEach((talent, index) => {
      if (talent.workCoords) {
        markers.push(
          <Marker
            key={`work-${talent.id}-${index}`}
            position={[talent.workCoords.lat, talent.workCoords.lng]}
            icon={getMarkerIcon(talent.originColor)}
            eventHandlers={onTalentClick ? { click: () => onTalentClick(talent) } : undefined}
          >
            <Popup>
              <div className="p-2">
                <h3 className="font-bold text-lg">{talent.fullName}</h3>
                <p className="text-sm"><strong>{t('workplaceName')}:</strong> {talent.workplaceName || t('unregistered')}</p>
                <p className="text-sm"><strong>{t('workplaceAddress')}:</strong> {talent.workplaceAddress || t('unregistered')}</p>
                <p className="text-sm"><strong>{t('originPlace')}:</strong> {talent.originCountry}</p>
                <p className="text-sm"><strong>{t('field')}:</strong> {talent.field || t('unregistered')}</p>
                {talent.salesStaffName && (
                  <p className="text-sm"><strong>{t('responsibleSales')}:</strong> {talent.salesStaffName}</p>
                )}
                <div className="mt-2">
                  <span
                    className="inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-xs font-medium"
                    style={{
                      backgroundColor: `${talent.originColor}20`,
                      color: talent.originColor
                    }}
                  >
                    <span
                      className="inline-block h-2.5 w-2.5 rounded-full"
                      style={{ backgroundColor: talent.originColor }}
                    />
                    {talent.originCountry}
                  </span>
                </div>
              </div>
            </Popup>
          </Marker>
        );
      }
    });

    return markers;
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96 bg-gray-50 rounded-lg">
        <div className="text-lg text-gray-600">{t('loadingMap')}</div>
      </div>
    );
  }

  if (mapTalents.length === 0) {
    return (
      <div className="flex justify-center items-center h-96 bg-gray-50 rounded-lg border border-dashed border-gray-200">
        <div className="text-center px-6">
          <p className="text-lg font-semibold text-gray-700">{t('noTalentsWithAddress')}</p>
          <p className="mt-2 text-sm text-gray-500">{t('unmappedNote')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-96 rounded-lg overflow-hidden shadow-lg">
      <div className="absolute right-3 top-3 z-[1000] max-h-[calc(100%-1.5rem)] w-56 overflow-hidden rounded-xl border border-slate-200 bg-white/95 p-3 shadow-lg backdrop-blur">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{t('mapLegendTitle')}</p>
        <div className="mt-3 space-y-2 overflow-y-auto pr-1">
          {legendItems.map((item) => (
            <div key={item.label} className="flex items-center justify-between gap-3 text-sm text-slate-700">
              <div className="flex min-w-0 items-center gap-2">
                <span
                  className="inline-block h-3 w-3 flex-shrink-0 rounded-full"
                  style={{ backgroundColor: item.color }}
                />
                <span className="truncate">{item.label}</span>
              </div>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
      <MapContainer
        center={[36.2048, 138.2529]} // 日本中心
        zoom={6}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {createMarkers()}
      </MapContainer>
    </div>
  );
};

export default JapanTalentMap;
